import { BehaviorSubject, filter, Observable, of, switchMap } from 'rxjs';
import { BoschUiPaginatorInterface } from '../../../basics/bosch-ui-paginator/bosch-ui-paginator-base';
import { BoschUiPageEvent } from '../../../basics/bosch-ui-paginator/bosch-ui-paginator.model';

export class BoschUiTableDataSource<DataType> {
  private _data: DataType[] = [];
  private _filter: string | null = null;
  private _sort: unknown | null = null;
  private _paginator: BoschUiPaginatorInterface | null = null;

  private _data$ = new BehaviorSubject<DataType[]>([]);

  public data$: Observable<DataType[]> = this._data$.pipe(
    filter(Boolean),
    switchMap((data: DataType[]) => {
      if (this._paginator) {
        return this._paginator.page$.pipe(
          switchMap((pageEvent: BoschUiPageEvent) => {
            const paginatedData: DataType[] = [];

            const startIndex = pageEvent.pageNumber * pageEvent.pageSize;
            const endIndex = startIndex + pageEvent.pageSize;

            for (let i = startIndex; i < endIndex; i++) {
              if (data[i]) {
                paginatedData.push(data[i]);
              }
            }

            return of(paginatedData);
          }),
        );
      }

      return of(data);
    }),
  );

  set data(data: DataType[]) {
    this._data = data;
  }

  get data(): DataType[] {
    return this._data;
  }

  set filter(filterString: string | null) {
    this._filter = filterString;
    const filteredData = [...this._data].filter((item: DataType) => {
      if (!filterString) {
        return true;
      }

      if ((item && typeof item === 'string') || typeof item === 'number' || typeof item === 'boolean') {
        return `${item}`.toLowerCase().includes(filterString);
      }

      if (item && typeof item === 'object') {
        return Object.values(item).some((value: unknown) => `${value}`.toLowerCase().includes(filterString));
      }

      return false;
    });

    if (this._paginator) {
      this._paginator.totalElements = filteredData.length;
    }

    this._data$.next(filteredData);
  }

  get filter(): string | null {
    return this._filter;
  }

  // TODO: implement later
  get sort(): unknown {
    return this._sort;
  }
  set sort(sort: unknown) {
    this._sort = sort;
  }

  // TODO: implement later
  get paginator(): BoschUiPaginatorInterface | null {
    return this._paginator;
  }
  set paginator(paginator: BoschUiPaginatorInterface | null) {
    this._paginator = paginator;
  }

  constructor(data: DataType[]) {
    this._data$.next((this._data = data));
  }
}
